import FooterCopyRights from "./FooterCopyRights";
export default FooterCopyRights;
